var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrozenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eec04047-d128-4f21-a77e-e1e2ee273da2",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.56 138.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.12,63.56,54.33,56.18,50.64,42.42,36.89,46.11,36,45.57,34,38.33l-6,1.61,1.47,5.49L24,46.9l1.61,6L32.86,51l.92.54,3.69,13.75,13.75-3.68L64,68.94Z",
    style: {
      fill: "#69b1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.64,96.3l3.69-13.76,12.79-7.39L64,69.77l-12.8,7.39L37.47,73.48,33.78,87.23l-.92.53-7.24-1.94-1.61,6,5.48,1.47L28,98.78l6,1.61L36,93.14l.93-.53Z",
    style: {
      fill: "#69b1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.89,91.82l-1.61-6L109,87.76l-.93-.53-3.68-13.75L90.68,77.16l-12.8-7.39-3.1,5.38,12.79,7.39L91.26,96.3,105,92.61l.92.53,1.94,7.25,6-1.61-1.47-5.49Z",
    style: {
      fill: "#67c6e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.28,52.89l1.61-6-5.49-1.47,1.47-5.49-6-1.61-1.94,7.24-.92.54L91.26,42.42,87.57,56.18,74.78,63.56l3.1,5.38,12.8-7.38,13.75,3.68,3.68-13.75L109,51Z",
    style: {
      fill: "#67c6e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,110.48l10.07-10.07L74.05,90.35V75.57H67.84V90.35L57.77,100.41l10.07,10.07v2.19l-5.3,5.3,4.39,4.39,4-4,4,4,4.4-4.39-5.31-5.3Z",
    style: {
      fill: "#69b1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.36,118l-5.31-5.3v-2.19l10.07-10.07L74.05,90.35V75.57H71v42.77l4,4Z",
    style: {
      fill: "#67c6e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,28.24V26.05l5.31-5.3L75,16.36l-4,4-4-4-4.39,4.39,5.3,5.3v2.19L57.77,38.3,67.84,48.37V63.15h6.21V48.37L84.12,38.3Z",
    style: {
      fill: "#69b1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,48.37,84.12,38.3,74.05,28.24V26.05l5.31-5.3L75,16.36l-4,4V63.15h3.1Z",
    style: {
      fill: "#67c6e4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.95,
    cy: 69.36,
    r: 9.32,
    style: {
      fill: "#69b1e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.26,69.36A9.32,9.32,0,0,0,71,60V78.68A9.32,9.32,0,0,0,80.26,69.36Z",
    style: {
      fill: "#67c6e4"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozenIcon);
export default __webpack_public_path__ + "static/media/frozen-icon.057396df4573c9937163ad633b69cff5.svg";
export { ForwardRef as ReactComponent };